import template from './summaries.html';

/** @ngInject */
function summariesConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Zestawienia',
    state: 'modules.summaries.employees',
    showInMenu: true,
    permissions: ['MANAGER', 'HEAD_TEACHER', 'TEACHER']
  });

  $stateProvider
    .state('modules.summaries', {
      url: '/summaries',
      abstract: true,
      views: {
        'content@': {
          template,
          controller: 'SummariesController as ctrl'
        }
      }
    })
    .state('modules.summaries.employees', {
      url: '/employees',
      views: {
        'summaries@modules.summaries': {
          component: 'absenceEmployeesComponent'
        }
      },
      resolve: {
        employees: EmployeeService => EmployeeService.getEmployeesWithoutSupply()
      }
    })
    .state('modules.summaries.students', {
      url: '/students',
      views: {
        'summaries@modules.summaries': {
          component: 'presenceStudentsComponent'
        }
      },
      resolve: {
        groups: GroupService => GroupService.getAllGroups(),
        students: StudentService => StudentService.getAll()
      }
    });
}

export default summariesConfig;
